import { FAILED, NO_TITLE_ERROR } from '@App/app/configs/toastr-events.config';
import { WARNING_TOASTR_CONFIG } from '@App/app/configs/toastr-messages.config';
import { Annotation } from '@App/app/entities/files/annotation.model';
import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NbToastrService } from '@nebular/theme';
import { ModelPhotoCardZoomAnnotationsBaseDirective } from './model-photo-card-zoom-annotations.base';
import { Annotations2dService } from './services/annotations2d-service/annotations2d.service';

@Component({
  selector: 'app-model-photo-card-zoom-annotations',
  templateUrl: './model-photo-card-zoom-annotations.component.html',
  styleUrls: ['./model-photo-card-zoom-annotations.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class ModelPhotoCardZoomAnnotationsComponent
  extends ModelPhotoCardZoomAnnotationsBaseDirective
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  constructor(
    fb: FormBuilder,
    annotations2dService: Annotations2dService,
    toastrService: NbToastrService,
  ) {
    super(fb, annotations2dService, toastrService);
  }

  ngOnInit() {
    this.annotorious = this.annotations2dService.createAnnotorious(this.htmlImage);
    this.annotorious.on('createSelection', this.createSelection);
    this.annotorious.on('cancelSelected', this.cancelSelection);
    this.annotorious.on('createAnnotation', this.createAnnotation);
    this.annotorious.on('selectAnnotation', this.selectAnnotation);
    this.annotorious.on('updateAnnotation', this.updateAnnotation);
    this.annotorious.on('deleteAnnotation', this.deleteAnnotation);
    this.annotorious.on('changeSelectionTarget', this.resizeAnnotation);
    this.initialized = true;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.annotorious.setAnnotations(
        this.annotations.map((ann, i) => {
          const id = `#${i}`;
          ann.localId = id;
          return ann.toAnnotoriousAnnotation(id, '', this.htmlImage);
        }),
      );
      this.updateAnnotationsUI();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.initialized) {
      if (changes.editingActive) {
        this.toggleEditMode(!changes.editingActive.currentValue);
      }
      if (changes.visible) {
        this.toggleVisibility(changes.visible.currentValue);
      }
    }
  }

  ngOnDestroy() {
    this.annotorious.destroy();
  }

  getAnnotationLabelClass(annotation: Annotation) {
    return {
      '--no-display':
        this.checkLabelIsOutOfBox(annotation) ||
        (this.editingActive && annotation.localId === this.selectedAnnotation?.localId),
      [`--${annotation.priority}`]: true,
    };
  }

  getAnnotationLabelStyle(annotation: Annotation) {
    const { localMinPx: min } = annotation;
    return {
      'margin-top': min?.y + 'px',
      'margin-left': min?.x + 'px',
      'max-width': this.htmlWrapper.offsetWidth - (min?.x || 0) - 2 + 'px',
    };
  }

  onSave() {
    if (this.editingForm?.valid) {
      this.annotations2dService.saveButton?.click();
    } else if (!this.editingForm?.controls?.title?.value.length) {
      this.toastrService.show(NO_TITLE_ERROR, FAILED, {
        ...WARNING_TOASTR_CONFIG,
      });
    }
  }

  onCancel() {
    this.annotations2dService.cancelButton?.click();
  }

  onDelete() {
    this.annotations2dService.deleteButton?.click();
  }

  private toggleEditMode(value: boolean) {
    this.annotorious.readOnly = value;
    this.onCancel();
  }

  private toggleVisibility(value: boolean) {
    this.annotations2dService.toggleVisibility(this.htmlWrapper, value);
    this.updateAnnotationsUI();
  }

  private checkLabelIsOutOfBox(annotation: Annotation) {
    const { localMinPx: min } = annotation;
    return (
      min &&
      (min.x < 0 ||
        min.y < 0 ||
        min.x > this.htmlWrapper.offsetWidth ||
        min.y > this.htmlWrapper.offsetHeight)
    );
  }
}
